import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { displayErrorMessage } from '../helper/utils/utils';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService, private toastr: ToastrService,) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    const token = this.authService.getToken();

    let headers = req.headers
      .set('Accept', 'application/json');
    if (token) {
      headers = headers.set('Authorization', `Bearer ${token}`);
    }
    const authReq = req.clone({ headers });

    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if(error.status === 401){
          this.authService.refreshToken()
        }
        if(error.status === 403){
          this.toastr.error("Unauthorized access. Please log in again or contact support");
        }
        this.handleHttpError(error);
        return throwError(() => error);
      })
    );
  }

  private handleHttpError(error: HttpErrorResponse) {
    if (!error.error || !error.error.errors) {
      return;
    }

    error.error.errors.forEach((errObj: Record<string, string>) => {
      Object.entries(errObj).forEach(([key, message]) => {
        displayErrorMessage(key, message);
      });
    });
  }

}